// extracted by mini-css-extract-plugin
export default {"tooltip":"bo-z","sharingV2":"co-z","sharingIconsV2":"do-z","links":"eo-z","link":"fo-z","facebookV2":"go-z","twitterV2":"ho-z","pinterestV2":"io-z"};